import { Routes } from '@angular/router';
import { AuthGuard } from '../core/guards/auth.guard';
import { PraticienGuard } from '../core/guards/praticien.guard';
import { ModuleGuard } from '../core/guards/module.guard';
import { APP_MODULES } from '../core/constants/app-modules.constants';

export const PRATICIEN_ROUTES: Routes = [
  {
    path: 'exercices/list',
    loadComponent: () => import('../features/exercices/list/list.component').then(m => m.ExercicesListComponent),
    canActivate: [AuthGuard, PraticienGuard, ModuleGuard],
    data: { modules: [APP_MODULES.EXERCICES] }
  },
  {
    path: 'exercices/add',
    loadComponent: () => import('../features/exercices/add/add.component').then(m => m.ExercicesAddComponent),
    canActivate: [AuthGuard, PraticienGuard, ModuleGuard],
    data: { modules: [APP_MODULES.EXERCICES] }
  },
  {
    path: 'exercices/edit/:id',
    loadComponent: () => import('../features/exercices/edit/edit.component').then(m => m.ExercicesEditComponent),
    canActivate: [AuthGuard, PraticienGuard, ModuleGuard],
    data: { modules: [APP_MODULES.EXERCICES] }
  },
  {
    path: 'praticien/agenda',
    loadComponent: () =>
      import('../features/praticien/agenda/agenda.component').then(m => m.PraticienAgendaComponent),
    canActivate: [AuthGuard, PraticienGuard, ModuleGuard],
    data: { modules: [APP_MODULES.AGENDA] }
  },
  {
    path: 'praticien/animations/list',
    loadComponent: () =>
      import('../features/praticien/animations/list/list.component').then(m => m.PraticienAnimationsListComponent),
    canActivate: [AuthGuard, PraticienGuard, ModuleGuard],
    data: { modules: [APP_MODULES.MEDIAS] }
  },
  {
    path: 'praticien/audios/list',
    loadComponent: () => import('../features/praticien/audios/list/list.component').then(m => m.PraticienAudiosListComponent),
    canActivate: [AuthGuard, PraticienGuard, ModuleGuard],
    data: { modules: [APP_MODULES.MEDIAS] }
  },
];
